var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "4b0d38e563541aab7bfabae130129f5b85723706"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-ca@rodi"] = {
  id: "4b0d38e563541aab7bfabae130129f5b85723706"
};